// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateWithColorWarnings_warning__RuAjb {
  color: rgba(241, 128, 0, 0.8);
  font-weight: bold;
}

.DateWithColorWarnings_danger__nVFxK {
  color: rgba(223, 40, 40, 0.8);
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Date/DateWithColorWarnings/DateWithColorWarnings.module.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,6BAAA;EACA,iBAAA;AACJ","sourcesContent":[".warning{\n    color: rgba(241,128,0,0.8);\n    font-weight: bold;\n}\n\n.danger{\n    color: rgba(223, 40, 40, 0.8);\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `DateWithColorWarnings_warning__RuAjb`,
	"danger": `DateWithColorWarnings_danger__nVFxK`
};
export default ___CSS_LOADER_EXPORT___;
